import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { contentStyles, titleStyles, wrapperStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";

const BookingEnded = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const navigate = useNavigate();
  const { darkMode } = useThemeStore();
  return (
    <Box onClick={() => navigate("/sessions")} sx={wrapperStyles(darkMode)}>
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>Session Ended</Typography>
        <Typography
          sx={{ color: "#64748b", font: "var(--body-xs)", fontWeight: 400 }}
        >
          Talent {notification?.data?.username} has ended the session for{" "}
          {notification?.title}.
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#9ca3af" : "#64748b",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default BookingEnded;
